import { authApi, type UpdateProfileParam } from "api/auth.api";
import { action, computed, makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import type { Project } from "types/project";
import type { Staff } from "types/staff";
import { setToken } from "utils/auth";

class UserStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "UserStore",
      properties: ["info", "token"],
      storage: window.localStorage,
    });
  }

  info: Partial<Staff> = {};
  token = "";

  @computed
  get projects(): Project[] {
    return this.info.projects ?? [];
  }

  @action
  async login(username: string, password: string) {
    const res = await authApi.login({ username, password });
    const token = res.data.token as string;
    setToken(token);
    this.token = token;
  }

  @action
  async getProfile() {
    const res = await authApi.profile();
    this.info = res.data as Staff;
  }

  @action
  async updateProfile(data: UpdateProfileParam) {
    const res = await authApi.updateProfile(data);
    const updatedInfo = (res.data ?? data) as Partial<Staff>;
    this.info = {
      ...this.info,
      ...updatedInfo,
    };
  }

  @action
  logout = () => {
    setToken("");
    this.token = "";
    this.info = {};
  };
}

const userStore = new UserStore();

export { userStore };
